import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { LoadingService } from '@app/core/services/loading.service';
import { IMAGE_STATUS } from '@app/shared/constants/image';
import { Subscription } from 'rxjs';
import { ImageSnippet } from './image-snippet.model';
import { ImageSnippetService } from '../../helpers/image-snippet.service';

@Component({
    selector: 'app-image-picker',
    templateUrl: './image-picker.component.html',
    styleUrls: ['./image-picker.component.scss'],
    standalone: false,
})
export class ImagePickerComponent implements OnInit, OnDestroy {
    @Output() imageChange: EventEmitter<File> = new EventEmitter<File>();
    @Output() imageSnippetChange: EventEmitter<ImageSnippet> = new EventEmitter<ImageSnippet>();

    image: ImageSnippet = {
        status: IMAGE_STATUS.INIT,
        file: undefined,
        source: '',
    };

    imageStatus = IMAGE_STATUS;

    private subscription: Subscription;

    constructor(private imageService: ImageSnippetService, public loadingService: LoadingService) {}

    ngOnInit(): void {
        this.loadingService.startLoading(this);
        this.subscription = this.imageService.imageSnippet$.subscribe((image: ImageSnippet) => {
            this.image = image;

            switch (image.status) {
                case IMAGE_STATUS.LOADING:
                case IMAGE_STATUS.INIT:
                    this.loadingService.startLoading(this);
                    break;
                case IMAGE_STATUS.FULFILLED:
                    this.imageSnippetChange.emit(image);
                    this.loadingService.endLoading(this);
                    break;
                default:
                    this.loadingService.endLoading(this);
            }

            if (image.file) {
                this.imageChange.emit(image.file);
            }
        });
    }

    openDialog(imageInput: HTMLInputElement): void {
        imageInput.click();
    }

    processFile(imageInput: HTMLInputElement): void {
        if (imageInput.files.length) {
            this.loadImageSnippet(imageInput.files[0]);
        }
    }

    private loadImageSnippet(source: File | Blob): void {
        this.imageService.loadImageSnippet(source);
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
